import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    boards: [],
    selectedBoard: null,
    isLoading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0,
    },
};

const projectBoardSlice = createSlice({
    name: "projectBoard",
    initialState,
    reducers: {
        setBoards: (state, action) => {
            state.boards = action.payload;
        },
        setSelectedBoard: (state, action) => {
            state.selectedBoard = action.payload;
        },
        addBoard: (state, action) => {
            state.boards.unshift(action.payload);
        },
        updateBoardInList: (state, action) => {
            const index = state.boards.findIndex(b => b._id === action.payload._id);
            if (index !== -1) {
                state.boards[index] = action.payload;
            }
            if (state.selectedBoard?._id === action.payload._id) {
                state.selectedBoard = action.payload;
            }
        },
        removeBoard: (state, action) => {
            state.boards = state.boards.filter(b => b._id !== action.payload);
            if (state.selectedBoard?._id === action.payload) {
                state.selectedBoard = null;
            }
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
    },
});

export const {
    setBoards,
    setSelectedBoard,
    addBoard,
    updateBoardInList,
    removeBoard,
    setLoading,
    setError,
    setPagination,
} = projectBoardSlice.actions;

export const ProjectBoardReducer = projectBoardSlice.reducer;